import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from "@mui/material";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";

const ConfirmationDialog = ({ open, title, message, onClose, onConfirm }) => {
    return (
        <Dialog open={open} onClose={() => onClose()} maxWidth="xs" fullWidth sx={{borderRadius:2}}>
            <DialogTitle
                sx={{
                    borderBottom: "1px solid #e0e0e0",
                    paddingBottom: 1,
                    marginBottom: 1,
                    fontWeight: 600,
                    fontSize: "1.2rem",
                    color: "#333"
                }}
            >
                {title}
            </DialogTitle>

            <DialogContent>
                <Typography sx={{ fontSize: "0.95rem", color: "#555" }}>
                    {message}
                </Typography>
            </DialogContent>

            <DialogActions sx={{ padding: "16px" }}>
                <ReusableButton
                    children={'Cancel'}
                    variant="outlined"
                    classNames={'gn-actionbtn-outline gn-actionbtn-color me-3'}
                    onClick={onClose}
                />
                <ReusableButton
                    children={'Confirm'}
                    variant="contained"
                    classNames={'gn-actionbtn'}
                    onClick={onConfirm}
                />
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
